var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.773 9.089 30.4 16l-6.627 6.911q-.4.432-1.074.688c-.674.256-.916.256-1.402.256H4.658q-1.238 0-2.148-.648c-.91-.648-.91-.954-.91-1.566V10.356q0-.918.91-1.566c.91-.648 1.323-.648 2.148-.648h16.639q.728 0 1.402.256c.674.256.807.4 1.074.688z"
})));
export { SvgLabel as ReactComponent };
export default __webpack_public_path__ + "static/media/label.2c049e00.svg";